export default __webpack_public_path__ + "static/media/aside-season.0c62f8d1.png";